module.exports = __webpack_public_path__ + "media/images/icons/question-square-fill-c5ff4134756e42a9723950e99ed7850d.png";